import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';


import { isUserAuthenticated, getLoggedInUser, hasPermission } from './helpers/authUtils';
import { PermissaoGeral } from './helpers/enums';
import ConsultasRealizadas from './pages/ConsultasRealizadas';
import Assistentes from './pages/Assistentes';
import AssistenteMedicos from './pages/AssistenteMedicos';
import TermosTelemedicina from './pages/account/TermosTelemedicina';
import Tutoriais from './pages/Tutoriais';
import FilaProcedimentos from './pages/FilaProcedimentos';
import FilaPaciente from './pages/FilaPaciente';
import FilaRelatorioAbertos from './Views/FilaProcedimentos/filaRelatorioAbertos';
//import CadastrarAtestado from './Views/Paciente/CadastrarAtestado';


//const PDF = React.lazy(()=> import('./pages/'))

// lazy load all the views
const Home = React.lazy(() => {
	console.log("hasPermission", hasPermission([
		PermissaoGeral.SecretariaTransporte,
		PermissaoGeral.ChefeTransporte,
		PermissaoGeral.ConsorcioTransporte
	]))
	if (
		// user.permissao === PermissaoGeral.SecretariaTransporte ||
		// user.permissao === PermissaoGeral.ChefeTransporte ||
		// user.permissao === PermissaoGeral.ConsorcioTransporte
		hasPermission([
			PermissaoGeral.SecretariaTransporte,
			PermissaoGeral.ChefeTransporte,
			PermissaoGeral.ConsorcioTransporte
		])
	) {
		return (import('./pages/Itinerarios'))
	} else {
		return (import('./pages/Home'))
	}
});
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const Cidades = React.lazy(() => import('./pages/Cidades'));
const Cadastro = React.lazy(() => import('./Views/Paciente/cadastro'));
const CadastroCidade = React.lazy(() => import('./Views/Cidade/cadastro'));
const CadastroAgenda = React.lazy(() => import('./Views/Agenda/cadastro'));
const CadastroProfissional = React.lazy(() =>
	import('./Views/Profissional/cadastro')
);
const CadastroHospital = React.lazy(() => import('./Views/Hospitais/cadastro'));
const CadastroVeiculo = React.lazy(() => import('./Views/Veiculos/cadastro'));
const CadastroItinerario = React.lazy(() => import('./Views/Itinerarios/cadastro'));
const CadastroCirurgia = React.lazy(() => import('./Views/Cirurgia/cadastro'));
const CadastroEspecialidade = React.lazy(() =>
	import('./Views/Especialidades/cadastro')
);
const CadastroReceita = React.lazy(() =>
	import('./Views/Paciente/CadastrarReceita')
);
const CadastroReceituario = React.lazy(() =>
	import('./Views/Paciente/CadastrarReceituario')
);
const Pacientes = React.lazy(() => import('./pages/Pacientes'));
const Profissional = React.lazy(() => import('./pages/Profissional'));
const MinhaConta = React.lazy(() => import('./pages/MinhaConta'));
const Hospitais = React.lazy(() => import('./pages/Hospitais'));
const Veiculos = React.lazy(() => import('./pages/Veiculos'));
const Itinerarios = React.lazy(() => import('./Views/Itinerarios/HomeItinerarios'));
const Percursos = React.lazy(() => import('./pages/Percursos'));
const Agenda = React.lazy(() => import('./pages/Agenda'));
const AgendaPaciente = React.lazy(() => import('./pages/AgendaPaciente'));
const AgendaMedico = React.lazy(() => import('./pages/AgendaMedico'));
const Samu = React.lazy(() => import('./pages/Samu'));
const CID = React.lazy(() => import('./Views/CID'));
const CadastrarAtestado = React.lazy(() =>
	import('./Views/Paciente/CadastrarAtestado')
);
const CadastroCirurgico = React.lazy(() =>
	import('./Views/Cadastro_Cirurgico/cadastro')
);

const CadastrarHistorico = React.lazy(() =>
	import('./Views/Paciente/CadastrarHistorico')
);

const historicoPaciente = React.lazy(() =>
	import('./Views/Paciente/historico')
);
const Especialidades = React.lazy(() => import('./pages/Especialidades'));
const Chat = React.lazy(() => import('./pages/Chat'));

// auth
const Login = React.lazy(() => import('./pages/auth/Login'));
const Logout = React.lazy(() => import('./pages/auth/Logout'));
const ForgetPassword = React.lazy(() =>
	import('./pages/account/ForgetPassword')
);
const Register = React.lazy(() => import('./pages/account/Register'));
const Registro = React.lazy(() => import('./pages/account/Registro'));
const ConfirmAccount = React.lazy(() => import('./pages/account/Confirm'));
const Exames = React.lazy(() => import('./pages/Exames'));

const CadastroSolicitacaoExame = React.lazy(() => import('./Views/Paciente/CadastrarSolicitacaoExames'));

const ReceitasAvulsas = React.lazy(() => import('./Views/ReceitasAvulsas/index'));

const Consultas = React.lazy(() => import('./Views/Consultas/index'));
const Rastreamento = React.lazy(() => import('./Views/Rastreamento/index'));
const PlanoPaciente = React.lazy(() => import('./Views/AreaPaciente/PlanoPaciente'));
const PlanoContratar = React.lazy(() => import('./Views/AreaPaciente/PlanoContratar'));
const Consorcios = React.lazy(() => import('./pages/Consorcios'));
const SearchRegister = React.lazy(() => import('./pages/SearchRegister'));


// handle auth and authorization

const PrivateRoute = ({ component: Component, roles, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			const isAuthTokenValid = isUserAuthenticated();
			if (!isAuthTokenValid) {
				// not logged in so redirect to login page with the return url
				return (
					<Redirect
						to={{ pathname: '/login', state: { from: props.location } }}
					/>
				);
			}

			const loggedInUser = getLoggedInUser();
			// check if route is restricted by role
			if (roles && roles.indexOf(loggedInUser.role) === -1) {
				// role not authorised so redirect to home page
				return <Redirect to={{ pathname: '/' }} />;
			}

			// authorised so return component
			return <Component {...props} />;
		}}
	/>
);

const defaultURL = () => {
	let user = getLoggedInUser();
	let defUrl = "/home";
	if (
		// user.permissao === PermissaoGeral.SecretariaTransporte ||
		// user.permissao === PermissaoGeral.ChefeTransporte ||
		// user.permissao === PermissaoGeral.ConsorcioTransporte
		hasPermission([
			PermissaoGeral.SecretariaTransporte,
			PermissaoGeral.ChefeTransporte,
			PermissaoGeral.ConsorcioTransporte
		])
	) {
		defUrl = "/itinerarios";
	}
	return (<Redirect to={defUrl} />)
}

const routes = [
	// auth and account
	{ path: '/login', name: 'Login', component: Login, route: Route },
	{ path: '/logout', name: 'Logout', component: Logout, route: Route },
	{
		path: '/forget-password',
		name: 'Forget Password',
		component: ForgetPassword,
		route: Route
	},
	{ path: '/register', name: 'Register', component: Register, route: Route },
	{ path: '/registro', name: 'Registro', component: Registro, route: Route },
	{ path: '/search-register', name: 'Search Register', component: SearchRegister, route: Route },

	{
		path: '/confirm',
		name: 'Confirm',
		component: ConfirmAccount,
		route: Route
	},

	// other pages
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Dashboard'
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Home'
	},
	{
		path: '/samu',
		name: 'Samu',
		component: Samu,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'CAdastro de Samu'
	},
	{
		path: '/cidade/cadastrar',
		name: 'Cadastrar Cidades',
		component: CadastroCidade,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Cidades'
	},
	{
		path: '/agendar',
		name: 'Cadastrar Agenda',
		component: CadastroAgenda,
		route: PrivateRoute,
		title: 'Cadastrar Agenda'
	},
	{
		path: '/cid',
		name: 'Cadastrar CID',
		component: CID,
		route: PrivateRoute,
		title: 'Cadastrar CID'
	},
	{
		path: '/usuario/cadastrar',
		name: 'Cadastrar Profissional',
		component: CadastroProfissional,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Profissional'
	},
	{
		path: '/usuarios/cadastrar/:id',
		name: 'Cadastrar Profissional',
		component: CadastroProfissional,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Profissional'
	},
	{
		path: '/hospital/cadastrar',
		name: 'Cadastrar Hospital',
		component: CadastroHospital,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Hospital'
	},
	{
		path: '/veiculo/cadastrar',
		name: 'Cadastrar Veículo',
		component: CadastroVeiculo,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Veículo'
	},
	{
		path: '/itinerario/cadastrar',
		name: 'Cadastrar Veículo',
		component: CadastroItinerario,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Veículo'
	},
	{
		path: '/edit/veiculo/:id',
		name: 'Cadastrar Veículo',
		component: CadastroVeiculo,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cadastrar Veículo'
	},
	{
		path: '/edit-itinerario/:id',
		name: 'Editar Itinerario',
		component: CadastroItinerario,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Editar Itinerario'
	},
	{
		path: '/paciente/cadastrar',
		name: 'Cadastrar Paciente',
		component: Cadastro,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastrar Paciente'
	},
	{
		path: '/paciente/editar/:id',
		name: 'Editar Paciente',
		component: Cadastro,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Editar  Paciente'
	},

	{
		path: '/paciente/atestadocadastrar/:id',
		name: 'Cadastrar Atestado',
		component: CadastrarAtestado,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastrar Atestado'
	},
	{
		path: '/paciente/cadastrocirurgico/:id',
		name: 'Cadastrar Atestado',
		component: CadastroCirurgico,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastro Cirúrgico'
	},
	{
		path: '/paciente/receitacadastrar/:id',
		name: 'Cadastrar Receita',
		component: CadastroReceita,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastrar Atestado'
	},
	{
		path: '/paciente/receituariocadastrar/:id',
		name: 'Cadastrar Receituario',
		component: CadastroReceituario,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastrar Receituario'
	},
	{
		path: '/paciente/cirurgiacadastrar/:id',
		name: 'Cadastrar Cirurgia',
		component: CadastroCirurgia,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastrar Cirurgia'
	},
	{
		path: '/especialidade/cadastrar',
		name: 'Cadastrar Especialidade',
		component: CadastroEspecialidade,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Cadastrar Especialidade'
	},
	{
		path: '/cidades',
		name: 'Cidades',
		component: Cidades,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Cidades'
	},
	{
		path: '/pacientes',
		name: 'Pacientes',
		component: Pacientes,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Pacientes'
	},
	{
		path: '/consultasRealizadas',
		name: 'ConsultasRealizadas',
		component: ConsultasRealizadas,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'ConsultasRealizadas'
	},
	{
		path: '/profissional',
		name: 'Profissional',
		component: Profissional,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Profissional'
	},
	{
		path: '/minhaConta',
		name: 'Minha Conta',
		component: MinhaConta,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Minha Conta'
	},
	{
		path: '/paciente/historicocadastrar/:id',
		name: 'Cadastrar Histórico',
		component: CadastrarHistorico,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Pacientes'
	},
	{
		path: '/paciente/historico/:id',
		name: 'Histórico',
		component: historicoPaciente,
		route: PrivateRoute,
		roles: ['Todos', 'Admin'],
		title: 'Pacientes'
	},
	{
		path: '/especialidades',
		name: 'Especialidades',
		component: Especialidades,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Especialidades'
	},
	{
		path: '/hospitais',
		name: 'Hospitais',
		component: Hospitais,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Hospitais'
	},
	{
		path: '/veiculos',
		name: 'Veículos',
		component: Veiculos,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Veículos'
	},
	{
		path: '/itinerarios',
		name: 'Itinerarios',
		component: Itinerarios,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Itinerarios'
	},
	{
		path: '/percursos',
		name: 'Percursos',
		component: Percursos,
		route: PrivateRoute,
		roles: ['Admin'],
		title: 'Percursos'
	},
	{
		path: '/agenda',
		name: 'Agenda',
		component: (Agenda),
		route: PrivateRoute,
		title: 'Agenda'
	},
	{
		path: '/agenda-medico',
		name: 'Agenda',
		component: AgendaMedico,
		route: PrivateRoute,
		title: 'Agenda'
	},
	{
		path: '/agenda-paciente',
		name: 'Agenda',
		component: AgendaPaciente,
		route: PrivateRoute,
		title: 'Agenda'
	},
	{
		path: '/exames',
		name: 'Exames',
		component: Exames,
		route: PrivateRoute,
		title: 'Exames',
		roles: ['Admin']
	},
	{
		path: '/paciente/cadastrarsolicitacaoexames/:id',
		name: 'Cadastro Solicitação Exames',
		component: CadastroSolicitacaoExame,
		route: PrivateRoute,
		title: "Cadastro Solicitação Exames",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/receitas/',
		name: 'Receitas Avulsas',
		component: ReceitasAvulsas,
		route: PrivateRoute,
		title: "Receitas Avulsas",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/consultas/',
		name: 'Agendamento Consultas',
		component: Consultas,
		route: PrivateRoute,
		title: "Agendamento Consultas",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/rastreamento/',
		name: 'Rastreamento',
		component: Rastreamento,
		route: PrivateRoute,
		title: "Rastreamento",
		roles: ['Admin']
	},
	{
		path: '/AreaPaciente/PlanoPaciente/',
		name: 'PlanoPaciente',
		component: PlanoPaciente,
		route: PrivateRoute,
		title: "Plano Paciente",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/AreaPaciente/PlanoContratar/',
		name: 'PlanoContratar',
		component: PlanoContratar,
		route: PrivateRoute, // precisa ser publico
		title: "Plano Contratar",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/consorcios/',
		name: 'Consórcios',
		component: Consorcios,
		route: PrivateRoute,
		title: "Consórcios",
		roles: ['Admin']
	},
	{
		path: '/assistentes/',
		name: 'Assistentes',
		component: Assistentes,
		route: PrivateRoute,
		title: "Assistentes",
		roles: ['Admin']
	},
	{
		path: '/assistenteMedicos/',
		name: 'Assistente Médicos',
		component: AssistenteMedicos,
		route: PrivateRoute,
		title: "Assistente Médicos",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/termosTelemedicinia/',
		name: 'Termos Telemedicina',
		component: TermosTelemedicina,
		route: Route,
		title: "Termos Telemedicina",
	},
	{
		path: '/tutoriais/',
		name: 'Tutoriais',
		component: Tutoriais,
		route: Route,
		title: "Tutoriais",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/filaPaciente/',
		name: 'Fila Paciente',
		component: FilaPaciente,
		route: Route,
		title: "Fila Paciente",
	},
	{
		path: '/filaEspera/',
		name: 'Fila Espera',
		component: FilaProcedimentos,
		route: PrivateRoute,
		title: "Fila Espera",
		roles: ['Admin', 'Todos']
	},
	{
		path: '/filaRelatorioAbertos/',
		name: 'Fila Relatorio Abertos',
		component: FilaRelatorioAbertos,
		route: PrivateRoute,
		title: "Fila Relatorio Abertos",
		roles: ['Admin', 'Todos']
	},
	// {
	//   path: '/chat',
	//   name: 'Chat',
	//   component: Chat,
	//   route: PrivateRoute,
	//   roles: ['Admin'],
	//   title: 'Chat'
	// },
	{
		path: '/',
		exact: true,
		component: defaultURL,
		route: PrivateRoute
	}
];





export { routes, PrivateRoute };
